<ui-card-table
  [showDrawer]="showDrawer"
  [hasBackdrop]="true"
  (openedDrawerChange)="openedDrawerChange($event)"
>
  <h4 card-title>Clientes</h4>
  <div card-search-action>
    <commonui-search (searchText)="onSearch($event)"></commonui-search>
  </div>

  <div
    card-drawer-content
    class="row align-items-start justify-content-start w-100 gx-0"
    commonui-loader
    [appLoader]="(dataSource.loading$ | async) ?? false"
  >
    <div class="col-12">
      <mat-table
        [dataSource]="dataSource"
        matSort
        matSortActive="email"
        matSortDisableClear
        matSortDirection="asc"
      >
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
            Email
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.email }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
            Nombre
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.firstname }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastname">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
            Apellidos
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.lastname }}
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <!-- PC ACTIONS LIST -->
        <ng-container matColumnDef="actions">
          <mat-header-cell
            class="action-col-centered justify-content-center"
            *matHeaderCellDef
          >
            <span class="d-none d-md-block">Acciones</span>
          </mat-header-cell>
          <mat-cell class="action-col-centered" *matCellDef="let item">
            <div class="d-none d-lg-flex">
              <!-- <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Editar"
                  (click)="openEditDialog(item)"
                >
                  <mat-icon svgIcon="pencil" class="me-1"></mat-icon>
                </button>
              </ng-container> -->

              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Eliminar"
                  (click)="openDeleteDialog(item)"
                >
                  <mat-icon
                    svgIcon="trash-can"
                    class="action_element"
                  ></mat-icon>
                </button>
              </ng-container>

              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Cambiar contraseña"
                  (click)="openChangePasswordDialog(item)"
                >
                  <mat-icon
                    svgIcon="password"
                    class="action_element"
                  ></mat-icon>
                </button>
              </ng-container>
            </div>

            <!-- MOBILE ACTIONS MENU-->
            <div class="d-block d-lg-none">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Acciones"
              >
                <mat-icon
                  svgIcon="expand_vert"
                  class="action_element"
                ></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <!-- <ng-container>
                  <button mat-menu-item (click)="openEditDialog(item)">
                    <mat-icon svgIcon="pencil"></mat-icon>
                    <span>Editar</span>
                  </button>
                </ng-container> -->

                <ng-container>
                  <button mat-menu-item (click)="openDeleteDialog(item)">
                    <mat-icon svgIcon="trash-can"></mat-icon>
                    <span>Eliminar</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <div class="w-100 text-center pt-3 text-muted" *matNoDataRow>
          Sin resultados para mostrar
        </div>
      </mat-table>
    </div>
  </div>
  <mat-paginator
    card-drawer-paginator
    [length]="(dataSource.total$ | async) ?? 0"
    [pageSize]="dataSource.PAGE_SIZE"
    [pageSizeOptions]="dataSource.PAGE_SIZE_OPTIONS"
    #paginator
  >
  </mat-paginator>
</ui-card-table>
